import { render, staticRenderFns } from "./VideoGenerationLibrary.vue?vue&type=template&id=2264fe6c&scoped=true&"
import script from "./VideoGenerationLibrary.vue?vue&type=script&lang=js&"
export * from "./VideoGenerationLibrary.vue?vue&type=script&lang=js&"
import style0 from "./VideoGenerationLibrary.vue?vue&type=style&index=0&id=2264fe6c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2264fe6c",
  null
  
)

export default component.exports